import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthPageLayout } from "./AuthPageLayout";
import { useEffect } from "react";
import { updateCurrentUser } from "wasp/client/operations";
import { type AuthUser } from "wasp/auth";
import { LoginForm } from "wasp/client/auth";
// import { useTranslation } from "../i18n/hooks";

export default function Login({ user }: { user: AuthUser }) {
  const location = useLocation();
  const googleLoginError = location.search.includes('error=already-signed-in-with-email');
  // const { t } = useTranslation();

  useEffect(() => {
    if(user){
      window.location.href = 'admin/dashboard';
    }
  }, [user]);
  return (
    <AuthPageLayout
    twoColumn={false}
    >
      {googleLoginError && (
        <div className="mt-12 p-4 text-sm rounded-lg bg-red-100 text-red-700">
          You already signed up with E-mail. Please try logging in with your E-mail instead of Google.
        </div>
      )}
      <LoginForm />
      <br />
      <span className="text-sm font-medium text-gray-900 dark:text-gray-900">
        Don't have an account yet?
        <Link to="/signup" className="underline">
        go to signup
        </Link>
        .
      </span>
      <br />
      <span className="text-sm font-medium text-gray-900">
      Forgot your password?
        <Link to="/request-password-reset" className="underline">
          reset it
        </Link>
        .
      </span>
    </AuthPageLayout>
  );
}
